/**
 * Envelope e lote de endosso: mesma regra para exibir cancelar/excluir (DELETE).
 * Não permitido em finalizado, cancelado, processando ou pendente.
 */
export function isEnvelopeOrBatchCancelable(status) {
  return (
    status !== 'finished' &&
    status !== 'canceled' &&
    status !== 'processing' &&
    status !== 'pending'
  );
}
